export default __webpack_public_path__ + "static/media/farm_challenge_pest_infestation.5d5c1e52.jpg";